'use strict'
module.exports = {
  NODE_ENV: '"production"',
  baseURL:'"https://dgserver.zsxsgzc.cn"',
  // baseURL: '"http://test02.gznotary.com"',
  // baseURL:'"https://mock.apifox.cn/m1/2599297-0-default"',
  fileURL:'"https://dgserver.zsxsgzc.cn"'
  // fileURL:'"http://test02.gznotary.com"'
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = rBKV
// module chunks = 33